export default {
  deliveryAddresses: [],
  deliveryAddress: undefined,
};
